import { Component, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { ThemeServiceHelper } from 'common/theme/service.helper';
import { BcVisitorInfoBuilderService } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/services/visitor-info-builder.service';
import { VisitorInfoModel } from 'shared/models/visitor-info/visitor-info.model';
import { Observable } from 'rxjs';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';

@Component({
  selector: 'app-preview-header',
  templateUrl: './preview-header.component.html',
  styleUrls: ['./preview-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PreviewHeaderComponent implements OnChanges {
  @Input() workItemId: string;
  @Input() workItemType: string;
  @Output() closeAction: EventEmitter<void> = new EventEmitter();

  public visitor$: Observable<VisitorInfoModel>;

  constructor(private visitorInfoBuilder: BcVisitorInfoBuilderService, private _changeDetector: ChangeDetectorRef) {
  }

  ngOnChanges() {
    if (this.workItemType && this.workItemId) {
      this.visitor$ = this.visitorInfoBuilder.observeVisitorData(this.workItemId, this.workItemType);
      this._changeDetector.detectChanges();
    }
  }

  get isChat() {
    return this.workItemType === WorkItemTypes.CHAT;
  }

  get isEmail() {
    return this.workItemType === WorkItemTypes.EMAIL;
  }

  get avatarThemeId(): number {
    return ThemeServiceHelper.getAvatarThemeId(this.workItemId);
  }

  getThemeClass() {
    return ThemeServiceHelper.getCssClass(this.workItemId);
  }

  closeLane() {
    this.closeAction.emit();
  }
}
